import PropTypes from 'prop-types';
import { businessIndustryList } from 'constants/register';
import { registerFormValidationErrorType } from 'modules/general/enums';
import generalStrings from 'modules/general/strings';
import RadioButtonGroup from 'modules/common/components/RadioButtonGroup';
import SectionDivider from 'modules/common/components/SectionDivider';

import {
  OtherIndustryInputLabel,
  OtherIndustryInputField,
  FormValidationError,
} from './BusinessIndustry.style';

const BusinessIndustry = ({
  formFieldsValues,
  formFieldsValidation,
  handleTextInputFieldChange,
  handleRadioBtnFieldChange,
}) => {
  const selectedBusinessIndustryObj =
    businessIndustryList.find(
      businessIndustry => businessIndustry.key === formFieldsValues.businessIndustry,
    ) || {};

  return (
    <>
      <RadioButtonGroup
        RadioButtonGroupArr={businessIndustryList}
        selectedRadioButton={selectedBusinessIndustryObj}
        handleRadioButtonClick={value => handleRadioBtnFieldChange('businessIndustry', value)}
      />
      {selectedBusinessIndustryObj.key === 'Other' && (
        <>
          <SectionDivider gap={12} />
          <OtherIndustryInputLabel>
            {generalStrings.registerForm.formOtherBusinessIndustryFieldLabel}
          </OtherIndustryInputLabel>
          <SectionDivider gap={4} />
          <OtherIndustryInputField
            type="text"
            value={formFieldsValues.otherbusinessIndustry}
            onChange={event => handleTextInputFieldChange('otherbusinessIndustry', event)}
          />
        </>
      )}
      {formFieldsValidation.businessIndustry === registerFormValidationErrorType.empty && (
        <>
          <SectionDivider gap={12} />
          <FormValidationError>
            {generalStrings.registerForm.formEmptyFieldErrorText(
              generalStrings.registerForm.formBusinessIndustryFieldLabel,
            )}
          </FormValidationError>
        </>
      )}
      {formFieldsValidation.otherbusinessIndustry === registerFormValidationErrorType.empty && (
        <>
          <SectionDivider gap={12} />
          <FormValidationError>
            {generalStrings.registerForm.formEmptyOtherRadioButtonErrorText}
          </FormValidationError>
        </>
      )}
    </>
  );
};

BusinessIndustry.propTypes = {
  formFieldsValues: PropTypes.shape().isRequired,
  formFieldsValidation: PropTypes.shape().isRequired,
  handleTextInputFieldChange: PropTypes.func.isRequired,
  handleRadioBtnFieldChange: PropTypes.func.isRequired,
};

export default BusinessIndustry;
